import { pluralizeOutcomeNoun } from "../entities/outcome.js";
function formatPercent(value) {
  return (value / 100).toLocaleString("en-US", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
}
function formatCurrencyPerOpp(value) {
  const fractionDigits = Math.abs(value) >= 10 ? 0 : 2;
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
}
function getRevenueImpactCopy(netRevenuePer1k, averageRevenuePerOpp) {
  if (averageRevenuePerOpp === void 0 || averageRevenuePerOpp <= 0) {
    return null;
  }
  const revenuePerOpp = netRevenuePer1k / 1e3;
  const revenueChangePercent = revenuePerOpp / averageRevenuePerOpp * 100;
  const formattedPercent = formatPercent(revenueChangePercent);
  const formattedRevenuePerOpp = formatCurrencyPerOpp(revenuePerOpp);
  const direction = revenuePerOpp >= 0 ? "increase" : "decrease";
  return {
    label: `${formattedPercent} (${formattedRevenuePerOpp}/opp)`,
    summary: `${direction} revenue per opp by ${formattedPercent} (${formattedRevenuePerOpp})`
  };
}
function getOutcomeImpactCopy(params) {
  const {
    netConversions,
    averageRevenuePerOpp,
    outcomeNoun,
    outcomePluralNoun,
    isRevenueOutcome
  } = params;
  const noun = outcomeNoun ?? "conversion";
  const pluralNoun = pluralizeOutcomeNoun(noun, outcomePluralNoun);
  const isRevenue = isRevenueOutcome ?? noun === "Inforce policy";
  const revenueImpactCopy = isRevenue ? getRevenueImpactCopy(netConversions, averageRevenuePerOpp) : null;
  if (revenueImpactCopy) {
    return {
      noun,
      pluralNoun,
      isRevenue,
      pillLabel: revenueImpactCopy.label,
      dialogLabel: revenueImpactCopy.label,
      sentence: revenueImpactCopy.summary
    };
  }
  if (isRevenue) {
    return {
      noun,
      pluralNoun,
      isRevenue,
      pillLabel: "Revenue impact",
      dialogLabel: "Revenue impact",
      sentence: "increase revenue"
    };
  }
  const formattedMagnitude = netConversions.toLocaleString(void 0, {
    maximumFractionDigits: 0,
    signDisplay: "always"
  });
  const formattedMagnitudeUnit = pluralizeOutcomeNoun(
    noun,
    pluralNoun,
    netConversions
  );
  return {
    noun,
    pluralNoun,
    isRevenue,
    pillLabel: `${formattedMagnitude} ${formattedMagnitudeUnit} per 1k calls`,
    dialogLabel: `${formattedMagnitude} per 1,000 calls`,
    sentence: `add ${formattedMagnitude} ${formattedMagnitudeUnit} for every 1,000 calls`
  };
}
export {
  getOutcomeImpactCopy,
  getRevenueImpactCopy
};
//# sourceMappingURL=outcomeImpactCopy.js.map
